import { toast } from "sonner";
import { MessageCircleOff, ShieldAlert } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";
import { fmtDate, todayIST } from "@/lib/format";

export function CustomerControls({ c, onChanged }) {
  const call = async (fn, msg) => { try { await fn(); toast.success(msg); onChanged(); } catch (e) { toast.error(errMsg(e)); } };
  const optOut = (v) => call(() => api.put(`/customers/${c.id}/whatsapp-optout`, { opt_out: !v }), v ? "WhatsApp messages switched on" : "WhatsApp messages stopped for this customer");
  const override = (days) => call(() => api.post(`/customers/${c.id}/credit-override`, { days }), days ? `Orders allowed for ${days} days despite dues` : "Credit hold back on");
  const overriding = (c.credit_override_until || "") >= todayIST();
  const held = c.credit_limit > 0 && c.balance > c.credit_limit && !overriding;
  return (
    <div className="mb-6 grid gap-3 md:grid-cols-2" data-testid="customer-controls">
      <div className="flex items-center justify-between rounded-2xl border border-[#E7E2D6] bg-white p-4">
        <div>
          <div className="flex items-center gap-2 text-sm font-semibold"><MessageCircleOff className="h-4 w-4 text-[#D96B43]" />WhatsApp messages</div>
          <div className="text-xs text-muted-foreground" data-testid="wa-optout-status">{c.wa_opt_out ? `Stopped${c.wa_opt_source ? ` by ${c.wa_opt_source}` : ""}. No automatic messages are sent.` : "On. They can reply STOP to opt out."}</div>
        </div>
        <Switch checked={!c.wa_opt_out} onCheckedChange={optOut} data-testid="wa-optout-switch" />
      </div>
      <div className={`flex items-center justify-between gap-3 rounded-2xl border p-4 ${held ? "border-rose-300 bg-rose-50" : "border-[#E7E2D6] bg-white"}`}>
        <div>
          <div className="flex items-center gap-2 text-sm font-semibold"><ShieldAlert className="h-4 w-4 text-rose-600" />Credit hold</div>
          <div className="text-xs text-muted-foreground" data-testid="credit-hold-status">
            {overriding ? `Owner allowed orders until ${fmtDate(c.credit_override_until)}` : held ? "On hold: new orders from their page are blocked until dues are cleared" : "Not on hold"}
          </div>
        </div>
        {overriding
          ? <Button size="sm" variant="outline" onClick={() => override(0)} data-testid="credit-override-clear-btn">End override</Button>
          : held && <Button size="sm" onClick={() => override(7)} className="bg-[#0F382C] hover:bg-[#134E3A]" data-testid="credit-override-btn">Allow orders for 7 days</Button>}
      </div>
    </div>
  );
}
